import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'focusMenu'
        }
    }

    init() {
        window.addEventListener('scroll', () => {
            document.querySelector("html").classList.remove('show-menu')
        })
    }

    focusMenu() {
        document.querySelector("html").classList.add('show-menu')
        document.activeElement.blur();
        document.querySelector(".c-nav-main__link").focus()
        document.querySelector(".c-header-navtoggle").focus()
    }

    destroy() {
        window.removeEventListener('scroll', () => {
            document.querySelector("html").classList.remove('show-menu')
        })
    }
}
